import React from "react";
import { Box, Button, Typography } from "@mui/material";
import RegisterForm from "../components/auth/RegisterForm";
import AuthShell from "../components/auth/AuthShell";

function RegisterPage({ goToLogin, onRegistered }) {
  return (
    <AuthShell
      background="linear-gradient(180deg, #f3f6fa 0%, #eaf0f7 100%)"
      heroBackground="linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)"
      formBackground="linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(250,252,255,0.98) 100%)"
      heroTone="light"
      heroBadge="Start clean. Start small."
      heroTitle="Build follow-through around something real."
      heroBody="TrustBud turns a goal into small daily habits, helps you stay visible, and makes restarting easier when life gets messy."
      heroBullets={[
        "Choose one direction that matters",
        "Break it into habits you can actually do",
        "Use one real person to help you stay in it",
      ]}
      heroNote="Build the loop first. Improve the plan as TrustBud learns what helps."
      eyebrow="Create account"
      title="Start your first habit loop."
      body="Set up your account now. You can shape the goal and accountability details once you’re in."
      maxWidth={1020}
      reverseOnDesktop
    >
      <RegisterForm onRegistered={onRegistered} />

      <Box
        sx={{
          pt: 2,
          borderTop: "1px solid #e4eaf1",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "center" },
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Typography variant="body2" sx={{ color: "#5f6978" }}>
          Already have an account?
        </Typography>
        <Button
          variant="outlined"
          onClick={goToLogin}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            px: 2,
            fontWeight: 700,
          }}
        >
          Back to login
        </Button>
      </Box>
    </AuthShell>
  );
}

export default RegisterPage;
